require('./article');
// require('./activate-button');
// require('./faqs');
// require('./format-money'); // removed
// require('./hotlinks');
// require('./input-group-tooltip');
// require('./input-loan-amount');
// require('./input-money');
// require('./input-properties');
// require('./input-question');
// require('./input-toggle');
// require('./legal-popup');
require('./postcoder/addressLookup');
require('./main-header');
require('./main-nav');
// require('./mortgage-functions');
require('./scroll-to');


//require('./update-target');

const domNode = document.getElementById('mainForm');
if(domNode) {
    import(/* webpackChunkName: "form" */ './form')
}

